<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-right">
      <el-button size="mini" style="margin-top: 5px" @click="search"
        >查询</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="editStaus"
        >修改托收状态</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="openDialog"
        >批量修改银行卡信息</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="excel2"
        >导出信息</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="importModel"
        >导入修改</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="insertHouse">添加房产</el-button>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="房产">
          <el-input
            size="mini"
            v-model="form.houseName"
            placeholder="输入房产搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="客户名称">
          <el-input
            size="mini"
            v-model="form.customerName"
            placeholder="输入客户名称搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="是否已设置托收">
          <el-select
            v-model="form.status"
            size="mini"
            filterable
            style="width: 70%"
            clearable
            placeholder="选择托收状态"
          >
            <el-option label="否" value="0" />
            <el-option label="是" value="1" />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item></el-descriptions-item>
      </el-descriptions>
      <!-- <div style="margin-top: 5px">
          <el-button size="mini" @click="excel2"> 导出 </el-button>
        </div> -->
      <el-table
        max-height="600px"
        :data="listData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="房产名称" prop="name" />
        <el-table-column label="银行账户" prop="card_account" />
        <el-table-column label="银行卡号" prop="card_number" />
        <el-table-column label="开户行" prop="customer_bank" />
        <el-table-column label="开户行所在地" prop="customer_bank_address" />
        <el-table-column label="账户类型" prop="customer_account_type" />
        <el-table-column label="客户协议号" prop="contract_number" />
        <el-table-column label="客户编号" prop="customer_no" />
        <el-table-column label="客户编号" prop="bank_no" />
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="托收状态" prop="status">
          <template slot-scope="data">
            {{ data.row.status == 0 ? "未托收" : "已托收" }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="prev, pager, next"
        :page-size="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="批量修改"
      :visible.sync="modal"
      width="60%"
      :before-close="handleClose"
      v-loading="loading"
    >
      <el-form ref="form" :model="createData" label-width="120px">
        <el-form-item label="银行账户">
          <el-input
            size="mini"
            v-model="createData.cardAccount"
            placeholder="输入银行账户"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input
            size="mini"
            v-model="createData.cardNumber"
            placeholder="输入银行账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行">
          <el-input
            size="mini"
            v-model="createData.customerBank"
            placeholder="输入开户行"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户行地址">
          <el-input
            size="mini"
            v-model="createData.customerBankAddress"
            placeholder="输入开户行地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="账户类型">
          <el-input
            size="mini"
            v-model="createData.customerAccountType"
            placeholder="输入账户类型"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户协议号">
          <el-input
            size="mini"
            v-model="createData.contractNumber"
            placeholder="输入客户协议号"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户编号">
          <el-input
            size="mini"
            v-model="createData.customerNo"
            placeholder="输入客户编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行行号">
          <el-input
            size="mini"
            v-model="createData.bankNo"
            placeholder="输入银行行号"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            size="mini"
            v-model="createData.remark"
            placeholder="输入备注"
            autosize
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否托收">
          <el-radio-group v-model="createData.status">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editSetting">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="导入文件"
      :visible.sync="importVisible"
      width="60%"
      :before-close="handleCloseImport"
      v-loading="loading"
    >
      <el-upload
        :action="url"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        accept=".xls,.xlsx"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
      >
        <el-button size="small" type="primary" class="texts">
          点击上传
        </el-button>
        <div slot="tip" class="el-upload__tip">
          <p>只能上传xls或xlsx文件，且不超过8M</p>
        </div>
      </el-upload>
      <el-button size="mini" @click="importEdit">导入</el-button>
    </el-dialog>
  </div>
</template>

    <script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "OrderBankDeductionSetting",
  components: {
    ErpTree,
  },
  data() {
    return {
      listData: [],
      form: {
        houseName: "",
        customerName: "",
        status: "",
        page: 1,
        pageSize: 20,
      },
      startDate: "",
      endDate: "",
      appearStartDate: "",
      appearEndDate: "",
      createStartDate: "",
      createEndDate: "",
      appearDate: "",
      totalCount: 0,
      pid: 0,
      houseId: 0,
      house: [],
      chargeitem: [],
      createData: {
        pid: 0,
        cardNumber: "",
        cardAccount: "",
        customerBank: "",
        contractNumber: "",
        customerAccountType: "",
        customerBankAddress: "",
        customerNo: "",
        bankNo: "",
        remark: "",
        status: 0,
      },
      datas: [],
      ids: [],
      modal: false,
      loading: false,
      importVisible: false,
      url: "",
      fileList: [],
      importData: [],
      multipleSelection: [],
      importForm: {
        route: "",
      },

      selectTreeId : 0,
    };
  },
  mounted() {
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/excel?" +
      "login_name=" +
      login +
      "&token=" +
      token;
  },
  watch: {
    "form.page"(n) {
      this.search();
    },
  },
  methods: {
    nodeClick(data) {
      this.selectTreeId = data.id;
      if (data.type == "project") {
        this.pid = data.id;
      }
      if (data.type == "room") {
        this.houseId = data.id;
      }
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
    },
    search() {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.form.pid = this.pid;
      this.loading = true;
      this.$myhttp
        .post("admin/BankDeduction/bankDeductionHouse", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            this.form.page = backdata.data.page;
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.datas = val;
      let ids = [];
      this.datas.map((req) => {
        ids.push(req.id);
      });
      this.ids = ids;
    },
    del(type) {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      let tips = "";
      if (type == 1) {
        tips = "此操作将删除已选中托收，是否继续操作？";
      } else {
        tips = "此操作将删除全部托收单，是否继续操作？";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$myhttp
            .post(
              "admin/BankDeduction/deleteDeduction",
              { ids: this.ids, pid: this.pid, type },
              {
                "Content-Type": "application/json",
              }
            )
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search();
                this.loading = false;
              } else {
                this.$message.error(backdata.data.msg);
                this.loading = false;
              }
            })
            .catch((err) => {
              this.$message.error(err);
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    openDialog() {
      if (this.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.createData = {
        pid: 0,
        cardNumber: "",
        cardAccount: "",
        customerBank: "",
        contractNumber: "",
        customerAccountType: "",
        customerBankAddress: "",
        customerNo: "",
        remark: "",
        status: 0,
      };
      this.modal = true;
    },
    handleClose() {
      this.modal = false;
    },
    createDeduction() {
      if (this.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      if (this.createStartDate == "") {
        this.$message.error("请选择计费周期开始时间");
        return;
      }
      if (this.createEndDate == "") {
        this.$message.error("请选择计费周期结束时间");
        return;
      }
      if (this.appearDate == "") {
        this.$message.error("请选择银行报盘日期");
        return;
      }
      this.loading = true;
      this.createData.pid = this.pid;
      this.createData.houseId = this.houseId;
      this.createData.startDate = this.createStartDate / 1000;
      this.createData.endDate = this.createEndDate / 1000;
      this.createData.appearDate = this.appearDate / 1000;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/BankDeduction/createDeduction", this.createData, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search(1);
                this.loading = false;
                this.handleClose();
              } else {
                this.loading = false;
                this.$message.error(backdata.data.msg);
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err);
            });
        } else {
          this.loading = false;
        }
      });
    },
    alertNotice() {
      this.$message.success("功能正在开发");
    },
    excel(type) {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      ERP.showLoading();
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.form.appearStartDate = this.appearStartDate / 1000;
      this.form.appearEndDate = this.appearEndDate / 1000;
      this.form.pid = this.pid;
      this.form.type = type;
      this.$myhttp
        .post("admin/BankDeduction/excel", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = imgurl + backdata.data.data;
            ERP.hideLoading();
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            ERP.hideLoading();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          ERP.hideLoading();
        });
    },
    importModel() {
      this.importVisible = true;
    },
    handleCloseImport() {
      this.importVisible = false;
    },
    //删除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file) {
      this.importForm.route = file.response[0];
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    handleSelectionChangeImport(val) {
      this.multipleSelection = val;
    },
    // 删除节点
    delNode() {
      if (this.multipleSelection.length == 0) {
        return;
      }
      let data = [];
      if (this.importData.length == this.multipleSelection.length) {
        this.importData = [];
        this.multipleSelection = [];
      } else {
        this.importData.map((req) => {
          let bool = true;
          this.multipleSelection.map((reqs) => {
            if (req.id == reqs.id) {
              bool = false;
            }
          });
          if (bool) {
            data.push(req);
          }
        });
      }
      this.importData = data;
    },
    importExcelData() {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/BankDeduction/importExcelData",
          { data: this.importData, pid: this.pid },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search(1);
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    excel2() {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      ERP.showLoading();
      this.form.pid = this.pid;
      this.$myhttp
        .post("admin/BankDeduction/bankDeductionHouseExcel", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = imgurl + backdata.data.data;
            ERP.hideLoading();
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            ERP.hideLoading();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          ERP.hideLoading();
        });
    },
    downloadExcel() {
      let url = imgurl + "/excel/回盘文件模板.xlsx";
      window.open("/office.html#/office?url=" + url, "_blank");
    },
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.createData.chargeItemId = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.createData.chargeItemId = [];
    },
    editStaus() {
      if (this.ids.length === 0) {
        this.$message.error("请选择房产");
        return;
      }
      this.loading = true;
      this.$myhttp
        .post(
          "admin/BankDeduction/editStatus",
          { ids: this.ids },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    editSetting() {
      if (this.ids.length === 0) {
        this.$message.error("请选择房产");
        return;
      }
      this.loading = true;
      this.$myhttp
        .post(
          "admin/BankDeduction/editSetting",
          {
            ids: this.ids,
            cardNumber: this.createData.cardNumber,
            cardAccount: this.createData.cardAccount,
            customerBank: this.createData.customerBank,
            contractNumber: this.createData.contractNumber,
            customerAccountType: this.createData.customerAccountType,
            customerBankAddress: this.createData.customerBankAddress,
            customerNo: this.createData.customerNo,
            bankNo: this.createData.bankNo,
            remark: this.createData.remark,
            status: this.createData.status,
          },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
            this.handleClose();
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
            this.handleClose();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
          this.handleClose();
        });
    },
    importEdit() {
      if (this.importForm.route == "") {
        this.$Message.error("文件不能为空!");
        return false;
      }
      this.loading = true;
      this.$myhttp
        .post("admin/BankDeduction/importExcelEdit", this.importForm, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          this.loading = false;
          // 异步执行成功后
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    // 添加房产
    insertHouse(){
      this.$confirm("确定添加‘" + this.form.houseName + "’以及下属的所有房产吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$myhttp
          .post("admin/BankDeduction/insertHouse",{
            pid : this.pid,
            house_id : this.selectTreeId
          }, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            if (backdata.data.code == 200) {
              this.$message.success(backdata.data.msg);
            } else {
              this.$message.error(backdata.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
            ERP.hideLoading();
          });
      });
    },
  },
};
</script>

    <style>
.d-left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 253px);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/bankDeductionSetting.vue